import * as React from 'react';
import { Box } from '../../../../components/box';
import { TrafficLightZone } from '../../../../api-service/clients';
import { zoneConfig } from './traffic-light-types';

interface ZoneChipProps {
  zone: TrafficLightZone;
  small?: boolean;
}

export function ZoneChip({ zone, small = false }: ZoneChipProps) {
  const cfg = zoneConfig[zone];
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: small ? 22 : 28,
        px: small ? 1 : 1.5,
        borderRadius: 16,
        backgroundColor: cfg.tint,
        color: cfg.accent,
        fontWeight: 600,
        fontSize: small ? '0.7rem' : '0.8rem',
        border: `1px solid ${cfg.accent}`,
        whiteSpace: 'nowrap',
      }}
    >
      {cfg.label}
    </Box>
  );
}
